import { useSearchParams } from "react-router-dom";
import { CalendarDays } from "lucide-react";
import { useAuth } from "../../store/AuthContext";
import { currentBusinessDate } from "../../utils/businessDay";
import { CashierOwnerSettlementPage } from "../cashier/CashierOwnerSettlementPage";
import { CashierExpensesPage } from "../cashier/CashierExpensesPage";
import { RestaurantExpensesPage } from "../restaurant/RestaurantExpensesPage";
import { RestaurantSettlementsPage } from "./RestaurantSettlementsPage";
import { RestaurantOwnerSettlementPage } from "./RestaurantOwnerSettlementPage";
import { AdminOwnerSettlementsPage } from "./AdminOwnerSettlementsPage";

const SECTIONS = [
  { id: "overview", label: "Overview" },
  { id: "expenses", label: "Expenses" },
  { id: "settlement", label: "Settlements" },
  { id: "history", label: "History" },
];

export const CashSettlementsPage = () => {
  const { role } = useAuth();
  const [searchParams, setSearchParams] = useSearchParams();
  const businessDate = searchParams.get("businessDate") || currentBusinessDate();
  const section = searchParams.get("section") || (role === "RESTAURANT" ? "history" : "overview");
  const sections = role === "RESTAURANT"
    ? SECTIONS.filter(({ id }) => id === "expenses" || id === "history")
    : role === "OWNER" || role === "ADMIN"
      ? SECTIONS.filter(({ id }) => id !== "expenses")
      : SECTIONS;

  const update = (key, value) => {
    const next = new URLSearchParams(searchParams);
    if (value) next.set(key, value);
    else next.delete(key);
    setSearchParams(next, { replace: true });
  };

  let content;
  if (role === "ADMIN" || role === "OWNER") {
    content = <AdminOwnerSettlementsPage embedded section={section} />;
  } else if (section === "expenses") {
    content = role === "BAR_CASHIER" ? <CashierExpensesPage /> : <RestaurantExpensesPage />;
  } else if (section === "history") {
    content = role === "BAR_CASHIER" ? <CashierOwnerSettlementPage /> : <div className="space-y-5"><RestaurantSettlementsPage /><RestaurantOwnerSettlementPage /></div>;
  } else if (role === "BAR_CASHIER") {
    content = <CashierOwnerSettlementPage />;
  } else if (role === "RES_CASHIER") {
    content = <div className="space-y-5"><RestaurantSettlementsPage /><RestaurantOwnerSettlementPage /></div>;
  } else {
    content = <div className="space-y-5"><RestaurantSettlementsPage /><RestaurantExpensesPage /></div>;
  }

  return <div className="space-y-4">
    <div className="flex flex-wrap items-center justify-between gap-3">
      <div><h1 className="font-display text-2xl font-bold text-slate-900">Cash &amp; Settlements</h1><p className="text-sm text-slate-500">Cash operations and settlement history</p></div>
      <div className="flex items-center gap-2 rounded-lg border border-slate-200 bg-white px-3 py-2">
        <CalendarDays className="h-4 w-4 text-slate-500" /><label htmlFor="cash-business-date" className="text-sm font-medium text-slate-700">Business Date</label>
        <input id="cash-business-date" type="date" value={businessDate} onChange={(event) => update("businessDate", event.target.value)} className="rounded border-0 bg-transparent text-sm outline-none" />
        <button type="button" onClick={() => update("businessDate", currentBusinessDate())} className="rounded-md border border-slate-200 px-2.5 py-1 text-xs font-semibold text-slate-700 hover:bg-slate-50">Today</button>
      </div>
    </div>
      <nav className="flex gap-1 overflow-x-auto border-b border-slate-200" aria-label="Cash and settlement sections">
      {sections.map((item) => <button key={item.id} type="button" onClick={() => update("section", item.id)} className={`shrink-0 border-b-2 px-4 py-2.5 text-sm font-medium ${section === item.id ? "border-gold-500 text-navy-900" : "border-transparent text-slate-500 hover:text-slate-800"}`}>{item.label}</button>)}
      </nav>
    <div className="min-w-0">{content}</div>
  </div>;
};
